<div #splashScreen id="splash-screen">
  <app-animated-logo></app-animated-logo>
</div>
